import { useDevices, useMediaContext } from '../MediaContext';
export const useAudioOutputList = () => {
    const { activeAudioDevice, setActiveAudioDevice } = useMediaContext();
    const { audioOutputDevices } = useDevices();
    return {
        devices: audioOutputDevices.map((d) => ({
            id: d.deviceId,
            label: d.label
        })),
        onDeviceSelect: setActiveAudioDevice,
        activeOutput: {
            enabled: !!audioOutputDevices.find((device) => device.deviceId === activeAudioDevice.id),
            id: activeAudioDevice.id,
            label: activeAudioDevice.label
        }
    };
};
//# sourceMappingURL=useAudioOutputList.js.map